class ProspaGeolocation {
	constructor(siteCountry, ipAddress, dummyMode) {

		if (dummyMode === undefined) {
			dummyMode = false;
		}

		siteCountry = siteCountry.toUpperCase();


		if (siteCountry && ipAddress) {

			// this.deleteSavedGeolocation();

			this.sessionGeolocation = null;
			this.storageGeolocation = null;
			this.prospaSettings = window.prospaSettings;
			this.ajaxURL = window.prospaGravityFormsVariables.ajaxUrl;
			this.ipAddress = ipAddress;
			this.currentPage = window.location.pathname;
			this.redirectURL = window.prospaSettings['sister-site-page'];

			if (siteCountry.toUpperCase() === 'AU') {
				this.siteCountry = 'AU';
				this.visitorCountry = 'NZ';
				if (dummyMode) {
					var justPageURL = this.redirectURL.replace('https://www.prospa.co.nz/', '').replace('https://www.prospa.com/', '');
					this.redirectURL = 'https://www.prospa.co.nz/' + justPageURL;
				}
			} else {
				this.siteCountry = 'NZ';
				this.visitorCountry = 'AU';
				if (dummyMode) {
					var justPageURL = this.redirectURL.replace('https://www.prospa.co.nz/', '').replace('https://www.prospa.com/', '');
					this.redirectURL = 'https://www.prospa.com' + justPageURL;
				}
			}

			if (dummyMode) {
				understrap.adminLog('(DUMMY MODE) Ignoring all real geolocation checks');
			} else {
				understrap.adminLog('(REAL MODE) Received request to check geolocation for ' + ipAddress + ' and ' + this.siteCountry);
			}

			this.setUpEvents();
			this.getSavedStorageGeolocation();
			this.getSavedSessionGeolocation();
			this.getVisitorsCountryByIPAddress(dummyMode);
		}

	}

	setUpEvents()
	{
		var allDestinationButtons = jQuery('.geolocation-destination');
		var country = jQuery('#geolocation-destination-country');
		var saveButton = jQuery('#geolocation-confirm-button');
		var dismissalButton = jQuery('#geolocation-modal .btn-close');
		var dontShowAgainContainer = jQuery('#geolocation-dont-show-again-container');
		var dontShowAgainCheckbox = jQuery('#geolocation-dont-show-again');

		var that = this;

		/**
		 * Process clicking on any destination button
		 */
		allDestinationButtons.on('click', function(e) {

			var thisDestinationButton = jQuery(this);

			allDestinationButtons.removeClass('active');
			thisDestinationButton.addClass('active');
			saveButton.removeClass('disabled').removeAttr('disabled');
			country.val(thisDestinationButton.attr('data-country'));
			dontShowAgainCheckbox.removeAttr('checked');

			// Work out whether to show or hide the "Do not show this again" checkbox
			if (thisDestinationButton.hasClass('geolocation-destination--this-one')) {
				dontShowAgainContainer.css('visibility', 'visible');
			} else if (thisDestinationButton.hasClass('geolocation-destination--other-one')) {
				dontShowAgainContainer.css('visibility', 'hidden');
			}

			e.preventDefault();
			return false;
		});

		dismissalButton.on('click', function(e) {
			var payload = {
				'event': 'dataLayerEvent',
				'eventCategory': 'geo popup interaction',
				'eventAction': 'dismissal click',
				'eventLabel': 'close'
			};

			// Send event to GA
			if (window.dataLayer) {
				window.dataLayer.push(payload);
			} else {
				understrap.adminLog('Pushing custom event', payload);
			}

			e.preventDefault();
			return false;
		});

		/**
		 * Process clicking on "Confirm" button
		 */
		saveButton.on('click', function(e) {

			var doNotShowAgainCheckbox = dontShowAgainCheckbox.is(':checked');
			var doTheRedirect = window.prospaSettings["site-country"] !== country.val();
			var redirectURL = that.redirectURL;
			var modal = jQuery("#geolocation-modal");

			var trackingEvent = 'dataLayerEvent';
			var trackingCategory = 'geo popup interaction';
			var trackingAction = 'confirm click';
			var trackingLabel = country.val() + (doNotShowAgainCheckbox ? ' dont show' : '');

			var payload = {
				'event': trackingEvent,
				'eventCategory': trackingCategory,
				'eventAction': trackingAction,
				'eventLabel': trackingLabel
			};

			// Send event to GA
			if (window.dataLayer) {
				window.dataLayer.push(payload);
			} else {
				understrap.adminLog('Pushing custom event', payload);
			}

			if (doTheRedirect) {

				modal.modal('hide');
				that.deleteSavedGeolocation();

				var tempLink = document.createElement("a");
				document.body.appendChild(tempLink);
				tempLink.style = "display: none";
				tempLink.href = redirectURL;
				tempLink.target = '_self';
				tempLink.click();
				document.body.removeChild(tempLink);

				/*window.open(
					redirectURL,
					'_self'
				);*/

			} else {
				that.doNotShowPopupInCurrentSession();

				if (doNotShowAgainCheckbox) {
					that.doNotShowPopupAnymore();
				}

				modal.modal('hide');
			}

			e.preventDefault();
			return false;
		});

	}

	deleteSavedGeolocation()
	{
		localStorage.removeItem('prospaGeolocation');
		sessionStorage.removeItem('prospaGeolocation');
	}

	/**
	 * Do not show popup in current session anymore
	 */
	doNotShowPopupInCurrentSession()
	{
		this.sessionGeolocation.do_not_show_popup = true;
		this.updateSessionGeolocation(this.sessionGeolocation);
	}

	/**
	 * Do not show popup anymore
	 */
	doNotShowPopupAnymore()
	{
		this.storageGeolocation.do_not_show_popup = true;
		this.updateStorageGeolocation(this.storageGeolocation);
	}

	/**
	 * Check if visitor is from the same country
	 * @returns {boolean}
	 */
	isVisitorFromSameCountry()
	{
		if (!this.prospaSettings["site-country"] === undefined || !this.sessionGeolocation || !this.sessionGeolocation.country_code || this.sessionGeolocation.country_code === null || this.sessionGeolocation.country_code === undefined || (!this.sessionGeolocation.country_code.includes('AU') && !this.sessionGeolocation.country_code.includes('NZ')) || this.sessionGeolocation.do_not_show_popup === true) {
			return true;
		}

		return this.prospaSettings["site-country"].toUpperCase() === this.sessionGeolocation.country_code.toUpperCase();
	}

	/**
	 * Get saved in localStorage geolocationStorage
	 * @returns {any|boolean}
	 */
	getSavedStorageGeolocation()
	{
		var geolocation = localStorage.getItem('prospaGeolocation');

		if (geolocation) {
			this.storageGeolocation = this.tryParseSavedGeolocation(geolocation);
		}
	}

	/**
	 * Get saved in localStorage geolocationStorage
	 * @returns {any|boolean}
	 */
	getSavedSessionGeolocation()
	{
		var geolocation = sessionStorage.getItem('prospaGeolocation');

		if (geolocation) {
			this.sessionGeolocation = this.tryParseSavedGeolocation(geolocation);
		}
	}

	/**
	 * Parsed saved in localStorage geolocationStorage from string to object
	 * @param savedGeolocation
	 * @returns {any|boolean}
	 */
	tryParseSavedGeolocation(savedGeolocation){

		try {
			var o = JSON.parse(savedGeolocation);
			if (o && typeof o === "object") {
				return o;
			}
		}
		catch (e) { }

		return false;
	}

	/**
	 * Get visotor's country by their IP address
	 * @param dummy
	 */
	getVisitorsCountryByIPAddress(dummy)
	{
		// @todo: Add the check for prospaGeolocation in localStorage too

		var localStorageValue = localStorage.getItem('prospaGeolocation');
		var sessionStorageValue = sessionStorage.getItem('prospaGeolocation');

		if (localStorageValue === null && sessionStorageValue !== null) {
			localStorage.setItem('prospaGeolocation', sessionStorageValue);
		}

		if (localStorage.getItem('prospaGeolocation') === null) {

			if (!dummy) {

				var that = this;

				jQuery.ajax({
					type: 'POST',
					dataType : "json",
					url : this.ajaxURL,
					data : {
						action: "lookup_geolocation",
						ip_address: this.ipAddress
					},
					success: function(response) {

						var countryCode = null;
						if (response.country_code) {
							countryCode = response.country_code.toUpperCase();
						}

						var geolocation = {
							country_code: countryCode,
							do_not_show_popup: false
						};

						that.updateSessionGeolocation(geolocation);
						that.updateStorageGeolocation(geolocation);

						that.maybeShowPopup();

					}
				});

			} else {

				understrap.adminLog('Running in a dummy mode - not making real calls to ipstack');

				var visitorCountry = 'AU';
				if (this.siteCountry === 'AU') {
					visitorCountry = 'NZ';
				}

				var geolocation = {
					country_code: visitorCountry,
					do_not_show_popup: false
				}

				this.updateSessionGeolocation(geolocation);
				this.updateStorageGeolocation(geolocation);

				this.maybeShowPopup();

			}
		} else {
			this.maybeShowPopup();
			understrap.adminLog('Skipping the API call');
		}


	}

	/**
	 * Maybe show popup
	 */
	maybeShowPopup()
	{
		var visitorFromWrongCountry = !this.isVisitorFromSameCountry();

		if (visitorFromWrongCountry) {
			// Check if the modal needs to be shown, show it and mark it so it is not shown in the same session again
			if (this.sessionGeolocation && this.storageGeolocation && this.sessionGeolocation.do_not_show_popup === false && this.storageGeolocation.do_not_show_popup === false) {
				jQuery("#geolocation-modal").modal('show');
				this.doNotShowPopupInCurrentSession();
			}
		}

	}

	/**
	 * Update geolocation in both sessionStorage and class instance
	 * @param geolocation
	 */
	updateSessionGeolocation(geolocation)
	{
		var currentValue = this.sessionGeolocation;

		if (!currentValue) {
			currentValue = {};
		}

		for (var i in geolocation) {
			if (Object.prototype.hasOwnProperty.call(geolocation, i)) {
				if (i !== 'do_not_show_popup' || (i === 'do_not_show_popup' && geolocation[i] === false)) {
					currentValue[i] = geolocation[i];
				}
			}
		}

		sessionStorage.setItem('prospaGeolocation', JSON.stringify(currentValue));
		this.sessionGeolocation = currentValue;
	}

	/**
	 * Update geolocation in both localStorage and class instance
	 * @param geolocation
	 */
	 updateStorageGeolocation(geolocation)
	{
		var currentValue = this.storageGeolocation;

		if (!currentValue) {
			currentValue = {};
		}

		for (var i in geolocation) {
			if (Object.prototype.hasOwnProperty.call(geolocation, i)) {
				if (i !== 'do_not_show_popup' || (i === 'do_not_show_popup' && (currentValue[i] === false || !currentValue[i]))) {
					currentValue[i] = geolocation[i];
				}
			}
		}

		localStorage.setItem('prospaGeolocation', JSON.stringify(currentValue));
		this.storageGeolocation = currentValue;
	}

	/**
	 * Create blank geolocation in sessionStorage and localStorage
	 */
	createBlankGeolocation() {
		var geolocationInitial = {
			'do_not_show_popup': false,
			'country_code': false,
		};

		this.updateStorageGeolocation(geolocationInitial);
		this.updateSessionGeolocation(geolocationInitial);
	}
}



export { ProspaGeolocation as default }

document.addEventListener("DOMContentLoaded", function() {

	if (typeof window.prospaSettings === 'object' && window.prospaSettings.hasOwnProperty('remote-ip-address') && window.prospaSettings.hasOwnProperty('geolocation-on') && window.prospaSettings['geolocation-on'] === '1') {
		understrap.adminLog('Geolocation is turned on');
		var geolocationDummyMode =  window.prospaSettings['geolocation-dummy-mode'];
		new ProspaGeolocation(window.prospaSettings['site-country'], window.prospaSettings['remote-ip-address'], geolocationDummyMode !== undefined ? geolocationDummyMode : false );
	} else {
		understrap.adminLog('Geolocation is turned off');
	}

});
